import Fade from "react-reveal/Fade";

export default function SectionSix() {
  return (
    <div className="flex flex-col text-center md:space-y-16 space-y-6">
      <Fade top>
        <h1 className="md:text-4xl text-3xl font-black uppercase">
          BERIKUT BEBERAPA HASIL DESAIN LOGO KAMI
        </h1>
      </Fade>
      <Fade bottom>
        <img
          src="/img/imgsec6.png"
          className="md:w-8/12 mx-auto"
          alt="LOGO LOGO"
        />
      </Fade>
    </div>
  );
}
